import React from "react"

import {
    Box,
    Grid,
    IconButton,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material"

import Icon from "@mdi/react"
import {
    mdiAlphaACircleOutline, mdiAlphaBCircleOutline, mdiAlphaNCircleOutline,
    mdiAlphaUCircleOutline,
    mdiCircleOutline,
    mdiContentDuplicate,
    mdiPencilOutline,
    mdiTrashCanOutline,
} from "@mdi/js"
import { DateTime } from "luxon"

import { BrandPriority } from "models"

interface ResearchCardProps
{
    data: BrandPriority
    selectedResearchId: string
    handleClone: () => void
    handleEdit: () => void
    handleDelete: () => void
}
interface ResearchCardState
{
}
export class ResearchCard extends React.Component<ResearchCardProps, ResearchCardState>
{
    constructor(props: ResearchCardProps)
    {
        super(props)
        this.state = {}
    }

    render ()
    {
        return (
            <div style={{ overflowX: 'hidden' }}>
                <Grid container
                      alignItems="center"
                      sx={{
                          backgroundColor: this.props.data.id === this.props.selectedResearchId ? "#e6ecff" : '#f9fafb',
                          pt: 1,
                          pb: 1,
                          pl: 2,
                          borderBottom: "2px solid lightgray"}}
                >
                    {
                        this.props.data.priority === "URGENTE" &&
                        <Grid item xs={0.5}>
                            <Icon path={mdiAlphaUCircleOutline} size={1} color={"#F15152"} />
                        </Grid>
                    }
                    {
                        this.props.data.priority === "ALTA" &&
                        <Grid item xs={0.5}>
                            <Icon path={mdiAlphaACircleOutline} size={1} color={"#ff8c00"} />
                        </Grid>
                    }
                    {
                        this.props.data.priority === "NORMALE" &&
                        <Grid item xs={0.5}>
                            <Icon path={mdiAlphaNCircleOutline} size={1} color={"#ffbf00"} />
                        </Grid>
                    }
                    {
                        this.props.data.priority === "BASSA" &&
                        <Grid item xs={0.5}>
                            <Icon path={mdiAlphaBCircleOutline} size={1} color={"#2CAC97"}/>
                        </Grid>
                    }
                    <Grid item xs={7.5}>
                        <Stack direction="row">
                            <Stack direction="column" sx={{ml: 3}}>
                                <Typography color="primary.main" sx={{ fontSize: "18px", fontWeight: '600', lineHeight: 1 }}>
                                    {this.props.data.name}
                                </Typography>
                                <Typography color="gray" sx={{ fontSize: "13px", fontWeight: '600' }}>
                                    {this.props.data.brand.name}
                                </Typography>
                                <Typography color="gray" sx={{ fontSize: "10px" }}>
                                    Salvata il {DateTime.fromISO(this.props.data.creationDate).toFormat("dd MMM yyyy")}
                                </Typography>
                            </Stack>
                        </Stack>

                    </Grid>
                    <Grid item xs={4}>
                        <Box textAlign={"right"}>
                            <Stack direction="row">
                                <Tooltip title="Modifica" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="edit"
                                        disableFocusRipple
                                        disableRipple
                                        onClick={this.props.handleEdit}
                                    >
                                        <Icon path={mdiPencilOutline} size={1} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Copia" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="copy"
                                        disableFocusRipple
                                        disableRipple
                                        onClick={this.props.handleClone}
                                    >
                                        <Icon path={mdiContentDuplicate} size={1}/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Elimina" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="delete"
                                        disableFocusRipple
                                        disableRipple
                                        onClick={this.props.handleDelete}
                                    >
                                        <Icon path={mdiTrashCanOutline} size={1} />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
